const changePasswordErrorCodes = {
  EXPIRED_ERROR_CODE: 'link.expired',
  USED_ERROR_CODE: 'link.used',
  INVALID_ERROR_CODE: 'link.invalid',
};

export default changePasswordErrorCodes;
